import { IconSvg, IconSvgProps } from "./icon"

export default function Spinner(props: IconSvgProps) {
  return (
    <IconSvg {...props}>
      <path d="M12 22.029C10.144 22.029 8.323 21.515 6.742 20.542C5.16 19.57 3.88 18.178 3.043 16.52C2.206 14.863 1.846 13.006 2.002 11.156C2.158 9.307 2.825 7.536 3.928 6.043C5.031 4.549 6.526 3.391 8.248 2.698C9.97 2.004 11.851 1.802 13.681 2.114C15.511 2.426 17.219 3.24 18.613 4.465C20.008 5.69 21.036 7.279 21.581 9.053" />
    </IconSvg>
  )
}
